/**
 * Maps Firebase error codes to user-friendly error messages
 * @param {Error} error - Firebase error object
 * @returns {string} - User-friendly error message
 */
export const getFirebaseErrorMessage = (error) => {
  // Handle Firebase error codes
  if (error.code) {
    switch (error.code) {
      // Authentication errors
      case 'auth/invalid-credential':
      case 'auth/wrong-password':
      case 'auth/user-not-found':
        return 'Invalid email or password. Please check your credentials and try again.';
      
      case 'auth/email-already-in-use':
        return 'This email is already registered. Please sign in or use a different email.';
      
      case 'auth/weak-password':
        return 'Password is too weak. Please use at least 6 characters.';
      
      case 'auth/invalid-email':
        return 'Invalid email address. Please check and try again.';
      
      case 'auth/user-disabled':
        return 'This account has been disabled. Please contact support.';
      
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Please wait a moment and try again.';
      
      case 'auth/operation-not-allowed':
        return 'This sign-in method is not enabled. Please contact support.';
      
      case 'auth/network-request-failed':
        return 'Network error. Please check your connection and try again.';
      
      case 'auth/popup-closed-by-user':
        return 'Sign-in popup was closed. Please try again.';
      
      case 'auth/cancelled-popup-request':
        return 'Another sign-in attempt is already in progress.';
      
      // Email verification errors
      case 'auth/email-not-verified':
        return 'Your email address has not been verified. Please check your inbox for the verification email.';
      
      case 'auth/expired-action-code':
        return 'This link has expired. Please request a new one.';
      
      case 'auth/invalid-action-code':
        return 'This link is invalid or has already been used.';
      
      // Password reset errors
      case 'auth/invalid-verification-code':
        return 'Invalid verification code. Please check and try again.';
      
      // Default case - try to extract message from error
      default:
        // If error.message contains the code, try to provide a generic message
        if (error.message && error.message.includes('auth/')) {
          return 'An authentication error occurred. Please try again or contact support if the problem persists.';
        }
        return error.message || 'An unexpected error occurred. Please try again.';
    }
  }
  
  // If no code, try to parse from message
  if (error.message) {
    // Check if it's a Firebase error message format
    if (error.message.includes('auth/invalid-credential')) {
      return 'Invalid email or password. Please check your credentials and try again.';
    }
    if (error.message.includes('auth/email-already-in-use')) {
      return 'This email is already registered. Please sign in or use a different email.';
    }
    if (error.message.includes('auth/weak-password')) {
      return 'Password is too weak. Please use at least 6 characters.';
    }
    if (error.message.includes('auth/network-request-failed')) {
      return 'Network error. Please check your connection and try again.';
    }
    
    // Return the message as-is if we can't parse it
    return error.message;
  }
  
  // Fallback
  return 'An unexpected error occurred. Please try again.';
};


